<div class="layout">

    <app-navigation authorized
        [forRoles]="['Admin', 'Buyer', 'AdnocCoordinator' ,'Supplier', 'SupplierAdmin', 'Reviewer', 'SuperAdmin', 'RoadshowFocalPoint']"></app-navigation>
    <router-outlet></router-outlet>
    <app-footer authorized
        [forRoles]="['Admin', 'Buyer', 'AdnocCoordinator' ,'Supplier', 'SupplierAdmin', 'Reviewer', 'SuperAdmin', 'RoadshowFocalPoint']"></app-footer>
    <notifications></notifications>
    <loader></loader>
</div>